import { message } from 'antd';
import * as API from '@/services/api';

export default {
  namespace: 'template',
  state: {
    temList: [],
    temParams: {},
    temPagination: {},
    companyOptions: [],
    canManagePublic: false,
    loading: false
  },
  effects: {
    *getTemList({ payload }, { call, put, select }) {
      const params = yield select((state) => state.template.temParams);
      const res = yield call(API.getTemList, { ...params, ...payload });
      if (res.code === 0) {
        const data = res.data;
        yield put({
          type: 'save',
          payload: {
            temList: data.data,
            temParams: { ...params, ...payload },
            temPagination: data.pagination,
          },
        });
      }
    },

    *getCompanyOptions(_, { call, put }) {
      const res = yield call(API.getTemplateCompanyOptions);
      if (res.code === 0) {
        yield put({
          type: 'save',
          payload: {
            companyOptions: res.data?.companies || [],
            canManagePublic: Boolean(res.data?.can_manage_public),
          },
        });
      }
    },

    *addTem({ payload }, { call, put }) {
      yield put({
        type: 'save',
        payload: {loading: true}
      })
      const res = yield call(API.addTem, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getTemList',
        });
      } else {
        message.error(res.message);
      }
      yield put({
        type: 'save',
        payload: {loading: false}
      })
    },
    *delTem({ payload }, { call, put }) {
      const res = yield call(API.delTem, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getTemList',
        });
      } else {
        message.error(res.message);
      }
    },
    *editTem({ payload }, { call, put }) {
      const res = yield call(API.editTem, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getTemList',
        });
      } else {
        message.error(res.message);
      }
    },
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
};
